import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { ReportKpiComponent } from "./report-kpi.component";
import { ToDataDefinitionModule } from "src/app/pipes/to-data-definition/to-data-definition.module";
import { ParseReportValueModule } from "src/app/pipes/parse-report-value/parse-report-value.module";
import { ParseReportEmojiModule } from "src/app/pipes/parse-report-emoji/parse-report-value.module";
import { ReportActionButtonComponentModule } from "../report-action-button/report-action-button.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ToDataDefinitionModule,
    ParseReportValueModule,
    ParseReportEmojiModule,
    ReportActionButtonComponentModule,
  ],
  declarations: [ReportKpiComponent],
  exports: [ReportKpiComponent],
})
export class ReportKpiComponentModule {}
